import React, { FC } from 'react';
import classes from './styles/index.module.scss';
import { DottedBox } from "../../../../../../components/DottedBox";
import { FlexBox } from "../../../../../../components/FlexBox";
import image from "../../../../../../images/AnimatedEmojies-512px-229.gif";

type CustomAreaImageType = {
    isDisabled?: boolean;
}

export const CustomAreaImage: FC<CustomAreaImageType> = (
    { isDisabled }
) => {
    return (
        <DottedBox>
            <FlexBox justify='center' align='middle' className={classes.customAreaImage}>
                {!isDisabled && (
                    <img alt='' src={image} className={classes.image}/>
                )}
            </FlexBox>
        </DottedBox>
    );
}